import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Layers, Lock } from 'lucide-react';
export function SolutionSection() {
  return <Section background="dark" className="relative overflow-hidden" data-id="element-246">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-247"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-600/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-248"></div>

      <div className="relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-249">
        <div className="flex-1" data-id="element-250">
          <div className="inline-block px-4 py-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-400 font-semibold text-sm mb-6" data-id="element-251">
            Presentando Barrier Shield Technology™
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-252">
            Ingeniería de Capas: <br data-id="element-253" />
            <span className="text-amber-400" data-id="element-254">El Escudo de Cristal</span>
          </h2>
          <p className="text-stone-300 text-lg mb-8 leading-relaxed" data-id="element-255">
            He decodificado la técnica de las altas pastelerías francesas para
            que puedas replicarla en tu casa. No necesitas herramientas
            costosas, necesitas entender la ciencia.
          </p>

          <ul className="space-y-6" data-id="element-256">
            <li className="flex items-start gap-4" data-id="element-257">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-258">
                <Lock className="w-5 h-5 text-amber-400" data-id="element-259" />
              </div>
              <div data-id="element-260">
                <h4 className="text-white font-bold text-lg" data-id="element-261">
                  Sellado Térmico
                </h4>
                <p className="text-stone-400" data-id="element-262">
                  Aprenderás a crear una barrera invisible de azúcar
                  caramelizada que actúa como un cristal.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4" data-id="element-263">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-264">
                <Layers className="w-5 h-5 text-amber-400" data-id="element-265" />
              </div>
              <div data-id="element-266">
                <h4 className="text-white font-bold text-lg" data-id="element-267">
                  Aislamiento de Humedad
                </h4>
                <p className="text-stone-400" data-id="element-268">
                  Impide físicamente que la humedad de la crema toque las capas
                  de hojaldre.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4" data-id="element-269">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-270">
                <CheckCircle2 className="w-5 h-5 text-amber-400" data-id="element-271" />
              </div>
              <div data-id="element-272">
                <h4 className="text-white font-bold text-lg" data-id="element-273">
                  Durabilidad Extrema
                </h4>
                <p className="text-stone-400" data-id="element-274">
                  Tu Mil Hojas se mantendrá crujiente por 48 horas, incluso en
                  climas húmedos.
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div className="flex-1 w-full" data-id="element-275">
          <div className="bg-stone-800 border border-stone-700 rounded-2xl p-8 relative overflow-hidden group hover:border-amber-500/50 transition-colors duration-300" data-id="element-276">
            <div className="absolute top-0 right-0 bg-amber-500 text-stone-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-277">
              MÉTODO PRO
            </div>

            <h3 className="text-2xl font-serif text-white mb-6" data-id="element-278">
              Lo que vas a lograr
            </h3>

            <div className="space-y-4" data-id="element-279">
              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-280">
                <span className="text-stone-300" data-id="element-281">Crujido (Decibelios)</span>
                <div className="flex items-center gap-2" data-id="element-282">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-283">
                    <div className="h-full bg-amber-500 w-[95%]" data-id="element-284"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-285">
                    ALTO
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-286">
                <span className="text-stone-300" data-id="element-287">Integridad Estructural</span>
                <div className="flex items-center gap-2" data-id="element-288">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-289">
                    <div className="h-full bg-amber-500 w-[100%]" data-id="element-290"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-291">
                    100%
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-292">
                <span className="text-stone-300" data-id="element-293">Tiempo de Vida</span>
                <div className="flex items-center gap-2" data-id="element-294">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-295">
                    <div className="h-full bg-amber-500 w-[90%]" data-id="element-296"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-297">
                    48H+
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-stone-700 text-center" data-id="element-298">
              <p className="text-stone-400 italic" data-id="element-299">
                "Es como ponerle un impermeable invisible a tu postre"
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}